import React from 'react'
import { Link } from "react-router-dom";

const OperatorCard = ({ operators }) => {
  return (
    <>
     <div className="listingSafari">
     <Link to="/operator/eagle-safaris/sharedsafari" className="oprators_boxes">
      <div className="card-body">
        <div className="logo_provide2">
        <img src={operators.image} alt="" className='w-100' />
        </div>
        <div className="provider_details px-2">
           <h6 className="pname py-3 border-top">{operators.title}</h6> 
           <div className="providerNamerating d-flex gap-4 align-items-center pb-3">
               {operators.features.map((feature, index) => (
              <div key={index} className="ratings">
                <p className="mb-0"> 5 
                <i className={feature.icon} style={{color: "#F7BF39", marginLeft: "10px"}}></i>
                <i className={feature.icon1} style={{color: "#F7BF39", marginLeft: "1px"}}></i>
                <i className={feature.icon2} style={{color: "#F7BF39", marginLeft: "1px"}}></i>
                <i className={feature.icon3} style={{color: "#F7BF39", marginLeft: "1px"}}></i>
                <i className={feature.icon4} style={{color: "#F7BF39", marginLeft: "1px"}}></i>
                </p>
              </div>
            ))}
            <div className="googlerating">
               <p className="mb-0">{operators.review}</p> 
            </div>
           </div>
        </div>
      </div>
      <div className="footer_provider">
        <Link to="" className="oprators_boxes" data-pjax="0">
          <div className="slect_safricound d-flex justify-content-around">
            {operators.footerfeatures.map((feature, index) => (
              <div key={index} className="parks_text text-center">
                <p>{feature.number}</p>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </Link>
        <div className="get_quote text-center">
          <Link to="" className="oprators_boxes"data-pjax="0">
          </Link>  
          <Link to="" className="get_quote_btn" data-pjax="0">
           GET A FREE QUOTE
          </Link>
        </div>
      </div>
     </Link>
     </div>
    </>
  )
}

export default OperatorCard